module.exports = __webpack_public_path__ + "static/media/pdf.9a549224.svg";